// frontend/src/context/AuthContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import { getMe } from '../services/me';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState({ user: null, entitlements: null, trialActive: false });

  async function hydrateMe() {
    try {
      const data = await getMe();
      setAuth(prev => ({
        ...prev,
        user: data.user,
        counters: data.counters,
        entitlements: data.entitlements,
        trialActive: !!data.trial_active,
      }));
    } catch (error) {
      if (error.status === 401) setAuth({ user: null, entitlements: null, counters: null, trialActive: false });
    }
  }

  // Carrega /api/me se já houver token salvo
  useEffect(() => {
    if (sessionStorage.getItem('token')) hydrateMe();
  }, []);

  // Exponha hydrateMe para ser chamado após o login
  return (
    <AuthContext.Provider value={{ auth, me: auth, setAuth, hydrateMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
